/* @jsxImportSource @emotion/react */
/* eslint-disable formatjs/no-literal-string-in-jsx */

import { css } from '@emotion/react'

import { TrafficDots } from './TrafficDots'

const MONO_FONT =
  "ui-monospace, 'SF Mono', Menlo, Monaco, 'Cascadia Mono', monospace"

const rootCss = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #252523;
  font-family: ${MONO_FONT};
  font-size: 12px;
  color: #8f8f8d;
  border-radius: 16px;
  overflow: hidden;
`

function PixelRobot() {
  return (
    <svg
      width="40"
      height="36"
      viewBox="0 0 48 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      <rect x="8" y="4" width="4" height="4" fill="#D97757" />
      <rect x="36" y="4" width="4" height="4" fill="#D97757" />
      <rect x="0" y="8" width="48" height="20" rx="2" fill="#D97757" />
      <rect x="12" y="14" width="4" height="8" fill="#252523" />
      <rect x="32" y="14" width="4" height="8" fill="#252523" />
      <rect x="4" y="28" width="8" height="8" fill="#D97757" />
      <rect x="20" y="28" width="8" height="8" fill="#D97757" />
      <rect x="36" y="28" width="8" height="8" fill="#D97757" />
    </svg>
  )
}

export function ClaudeCodeInterface() {
  return (
    <div css={rootCss} aria-hidden>
      <div
        className="flexbox flexbox-align-center flexbox-no-shrink"
        style={{ gap: 10, height: 38, padding: '0 14px' }}
      >
        <TrafficDots color="#4E4E4C" />
        <span>MCP</span>
      </div>
      <div
        className="flexbox flexbox-column flexbox-grow"
        style={{ padding: '10px 18px 32px', minHeight: 0 }}
      >
        <div className="flexbox flexbox-gap-12">
          <PixelRobot />
          <div style={{ lineHeight: 1.6 }}>
            <div>
              <span style={{ color: '#FFF', fontWeight: 700 }}>
                Claude Code
              </span>{' '}
              v2.1.220
            </div>
            <div>Opus 5 (1M context)</div>
            <div>/Users/slite</div>
          </div>
        </div>
        <div className="flexbox-grow" style={{ minHeight: 24 }} />
        <div className="text-align-right" style={{ fontSize: 11.5 }}>
          <span style={{ color: '#D97757' }}>●</span> high · /effort
        </div>
        <div
          style={{
            borderTop: '1px solid #3A3A38',
            borderBottom: '1px solid #3A3A38',
            padding: '8px 0',
            margin: '8px 0',
            whiteSpace: 'nowrap',
          }}
        >
          <span style={{ color: '#FFF', fontWeight: 700 }}>❯</span>{' '}
          <span style={{ color: '#D9D9D7' }}>Try "fix lint errors"</span>
        </div>
        <div style={{ fontSize: 11.5, paddingBottom: 8 }}>
          " manual mode on · ? for shortcuts
        </div>
      </div>
    </div>
  )
}
